module.exports = __webpack_public_path__ + "static/media/cheryl_wu.bd22744a.png";